export default __webpack_public_path__ + "static/media/sanwalimg.30d87869.png";